import { defineComponent as _defineComponent } from 'vue'
import CarouselArrowButton from 'JS/components/carousels/CarouselArrowButton.vue';
import CarouselTrackingService from 'JS/services/CarouselTrackingService';
import CompareSimilarProductCard from './CompareSimilarProductCard.vue';
import { CarouselType, ICarouselClickData, ICarouselClickGtmData, ICarouselViewData, ICarouselViewGtmData, IProductCarouselGtmProduct } from 'JS/types/Carousel';
import { computed, onMounted } from 'vue';
import { getPriceMode } from "JS/types/Product";
import { handleTrackingLinkClick } from 'JS/utilities/carousel-tracking';
import { IPdpSimilarProduct } from 'JS/types/PDP';


export default /*#__PURE__*/_defineComponent({
  __name: 'CompareSimilarProducts',
  props: {
    products: null
  },
  emits: ["add-to-cart"],
  setup(__props: any, { emit }: { emit: ({
	(event: 'add-to-cart'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	products: IPdpSimilarProduct[],
}





const trackingService = new CarouselTrackingService();

let viewImpressionUrl = null;
let carouselView: ICarouselViewData | null = null;

const displayProducts = computed(()=> ({
	first: props.products[0],
	comparisons: props.products.slice(1),
}));


const showRatingColumn = computed<boolean>(()=> {
	return !!props.products.find(p => p.avgRating);
});

const showSwatchColumn = computed<boolean>(()=> {
	return !!props.products.find(p => p.swatches?.length > 1);
});

function trackClick(e: MouseEvent, product: IPdpSimilarProduct, index: number) {
	const clickData: ICarouselClickData = {
		blainNumber: product.blainNumber,
		currentPrice: product.price.currentPrice,
		carousel: carouselView,
		itemIndex: index,
	};

	const gtmData: ICarouselClickGtmData = {
		itemListID: `carousel_${carouselView.type.toString()}`,
		itemListName: carouselView.carouselName,
		currentPrice: product.price.currentPrice,
		belowMap: product.price.isBelowMAP,
		priceMode: getPriceMode(product.price),
		blainNumber: product.blainNumber,
		vendorBrand: product.brand,
		productName: product.name,
		index: index
	};

	handleTrackingLinkClick(e, () => trackingService.trackClick(clickData, gtmData));
}

async function trackView() {
	if (viewImpressionUrl) return;

	viewImpressionUrl = window.location.pathname + window.location.search;

	carouselView = {
		type: CarouselType.SIMILAR_PRODUCTS,
		carouselName: "Compare Similar",
		url: viewImpressionUrl
	};

	const carouselProducts: IProductCarouselGtmProduct[] = [];
	props.products.forEach(product => {
		carouselProducts.push({
			blainNumber: product.blainNumber,
			vendorBrand: product.brand,
			productName: product.name,
			price: product.price,
			belowMap: product.price.isBelowMAP,
			priceMode: getPriceMode(product.price),
		});
	});

	const gtmData: ICarouselViewGtmData = {
		itemListID: `carousel_${carouselView.type.toString()}`,
		itemListName: carouselView.carouselName,
		carouselProducts
	};

	await trackingService.trackViews([gtmData]);

	// Also sent to GTM
	window.blainGtmDataLayer.push({
		'event': "compare_products"
	});
}


onMounted(async () => {
	await trackView();
});


return { __sfc: true,props, emit, trackingService, viewImpressionUrl, carouselView, displayProducts, showRatingColumn, showSwatchColumn, trackClick, trackView, CarouselArrowButton, CompareSimilarProductCard }
}

})